var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Loader'),_vm._l((this.announcements),function(ex,k){return _c('Announcement',{key:k,attrs:{"data":ex}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }